module.exports = __webpack_public_path__ + "assets/home-img-grey-min.628f418eae71e7fbef7e47fa89890522.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./public/img/home-img-grey-min.jpg
 ** module id = 374
 ** module chunks = 0
 **/